import { Link } from 'react-router-dom';
import styled from 'styled-components';

const Card = styled.article`
  display: flex;
  flex-direction: column;
  background: ${({theme})=>theme.gradients.card};
  border: 1px solid ${({theme})=>theme.colors.border};
  border-radius: ${({theme})=>theme.radius.md};
  overflow: hidden;
  transition: transform .25s ease, box-shadow .25s ease, border-color .25s ease;
  cursor: pointer;
  &:hover {
    transform: translateY(-6px) scale(1.02);
    box-shadow: ${({theme})=>theme.shadows.md};
    border-color: rgba(0,0,0,0.08);
  }
`;

const Cover = styled.img`
  width: 100%;
  aspect-ratio: 16/9;
  object-fit: cover;
  transition: transform .3s ease;
  position: relative;
  ${Card}:hover & {
    transform: scale(1.05);
  }
`;

const Meta = styled.div`
  padding: 1rem 1.25rem 1.5rem;
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const Title = styled(Link)`
  margin: 0 0 .5rem;
  font-size: 1.25rem;
  font-family: ${({theme})=>theme.fonts.heading};
  color: ${({theme})=>theme.colors.text};
  font-weight: 700;
  transition: color .25s ease;
  ${Card}:hover & {
    color: ${({theme})=>theme.colors.primary};
  }
`;

const Excerpt = styled.p`
  margin: 0 0 1rem;
  line-height: 1.5;
  color: ${({theme})=>theme.colors.muted};
  flex: 1;
`;

const ReadMore = styled(Link)`
  color: ${({theme})=>theme.colors.primary};
  font-weight: 600;
  align-self: flex-start;
  display: inline-flex;
  gap: .25rem;
  transition: transform .3s ease;
  &::after{content:'→';transition: transform .3s ease;}
  &:hover{transform: translateX(4px);} 
  &:hover::after{transform: translateX(2px);} 
`;

export default function PostCard({ post }) {
  return (
    <Card>
      <Link to={`/post/${post.slug}`}><Cover src={post.coverImage} alt={post.title}/></Link>
      <Meta>
        <Title to={`/post/${post.slug}`}>{post.title}</Title>
        <Excerpt>{post.excerpt}</Excerpt>
        <ReadMore to={`/post/${post.slug}`}>Leer más</ReadMore>
      </Meta>
    </Card>
  );
}
